module.exports = __webpack_public_path__ + "img/api.05d18839.svg";